ColumnasEditDialogCtrl.$inject = ['$log', '$scope', '$http'];
export default function ColumnasEditDialogCtrl($log, $scope, $http) {

    var URL_EDIT_OCULTAR_COLUMNAS = Sigo.var.path + '/usuarios/edit-ocultar-columnas';

    var vm = this;

    vm.cargando = {
        datos: false,
        submit: false
    };

    vm.tablas = ['incidencia', 'tarea'];
    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;

    vm.opcionesSiONo = [
        {label: StringUtils.ucfirst(Lang.choice('nombres.si', 1)), value: true},
        {label: StringUtils.ucfirst(Lang.choice('nombres.no', 1)), value: false}
    ];

    vm.formDeshabilitado = false;

    var filterColumns = function (elemento) {
        return issetAndNotEmpty(elemento.mDataProp) && (issetAndNotEmpty(elemento.mRender) || !issetAndNotEmpty(elemento.bVisible) || elemento.bVisible);
    };

    var columnasInciVisibles = IncidenciasGridCtrl.getColumnas().filter(filterColumns);

    var columnasTarVisibles = TareasGridCtrl.getColumnas().filter(filterColumns);

    vm.columnas = columnasInciVisibles;

    vm.renderColumna = function (columna) {
        return ucfirst(typeof columna.sTitle !== "undefined" ? columna.sTitle : columna.mDataProp);
    };

    vm.actualizaColumnas = function (tabla) {
        switch (tabla) {
            case 'incidencia':
                vm.columnas = columnasInciVisibles;
                break;
            case 'tarea':
                vm.columnas = columnasTarVisibles;
        }

        vm.model.columna = null;
    };

    vm.editarColumnasOcultasSrv = function (modelo) {
        modelo.opciones = {"ocultar": modelo.ocultar};

        var url = URL_EDIT_OCULTAR_COLUMNAS + '/' + modelo.tipo + '/' + modelo.userOrGroupId;
        var promesa = $http.post(url, modelo);
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;
        promesa.then(function (data) {
            vm.model = data.data;
            vm.dialogHandler.close(modelo);
        }, function () {
            vm.cargando.submit = false;
            vm.formDeshabilitado = false;
        });
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    };
}